var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input_warn_body",class:{input_warn_body2: _vm.level == 2 ? true : false},style:(_vm.sty)},[_c('img',{attrs:{"src":require("../../mycomponents/img/dialog/icon_cwts@2x.png"),"alt":""}}),_vm._v(_vm._s(_vm.mess)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }